import React from "react";

const Logo = () => {
    return(
        <div className="logo">
            <img src="../images/logo.png" alt="logo" />
        </div>
    )
}

export default Logo;